// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__19UbH","title":"AfterImages45_title__1xDxJ","images":"AfterImages45_images__3FDBP"};